import React, { useState, useEffect } from 'react'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import StyledModal from '../../components/StyledModal/Modal'
import StyledSelectField from '../../components/StyledSelectField/StyledSelectField'
import StyledTextFieldWithLabel from '../../components/StyledTextFieldWithLabel/StyledTextFieldWithLabel'
import { ToolsData, TypeAddToolData } from '../../types/tools'
import { OptionItem } from '../../types/common'

interface Props {
  isModalOpen: boolean
  closeHandler: () => void
  selectedTool: ToolsData | null
  addTool?: (toolData: TypeAddToolData) => void
  editTool?: (toolId: string, newData: TypeAddToolData) => void
  isEditMode?: boolean
  isLoading?: boolean
}

const ToolUploadModal = (props: Props) => {
  let defaultToolIdNo = ''
  let defaultToolType: OptionItem = {
    value: 0,
    label: 'Select tool type'
  }
  let defaultToolSize = ''
  let defaultToolLife = 0

  if (props.isEditMode && props.selectedTool) {
    defaultToolIdNo = props.selectedTool.toolId

    defaultToolType.value = props.selectedTool.toolType
    defaultToolType.label = props.selectedTool.toolType

    defaultToolLife = props.selectedTool.toolLife

    defaultToolSize = props.selectedTool.toolSize
  }

  const [toolTypeOptions, setToolTypeOptions] = useState([])
  const [toolIdNo, setToolIdNo] = useState(defaultToolIdNo)
  const [toolType, setToolType] = useState(defaultToolType)
  const [toolSize, setToolSize] = useState(defaultToolSize)
  const [toolLife, setToolLife] = useState(defaultToolLife)

  useEffect(() => {
    fetch(`${process.env.REACT_APP_ADMIN_BASE_URL}/v1/tool-type`)
      .then((response) => response.json())
      .then((data) => {
        const toolTypeOptions = data.data.map((item: any) => ({
          value: item.id,
          label: item.type
        }))
        setToolTypeOptions(toolTypeOptions)
      })
      .catch((error) => {
        console.log(error)
      })
  }, [])

  return (
    <StyledModal
      width={500}
      loading={props.isLoading}
      isOpen={props.isModalOpen}
      title={props.isEditMode ? 'Edit tool info' : 'Add tool'}
      closeHandler={() => props.closeHandler()}
    >
      <Stack
        spacing={2}
        direction="column"
        sx={{ marginBottom: '16px', width: '100%' }}
      >
        <StyledSelectField
          label="Tool type"
          placeholderText="Enter tool type"
          selectedValue={toolType}
          selectOptions={toolTypeOptions}
          onChangeHandler={(value: OptionItem) => setToolType(value)}
          isMulti={false}
          isSearchable={true}
          isDisabled={false}
          noOptionsMessage="No tool type found"
        />
        <StyledTextFieldWithLabel
          label="Tool size"
          placeholderText="Enter tool size"
          textValue={toolSize}
          onChangeHandler={(e: React.ChangeEvent<HTMLInputElement>) => {
            setToolSize(e.target.value)
          }}
          isDisabled={false}
          type="text"
          isMargin={true}
          noOptionsMessage="No tool size entered"
        />
        <StyledTextFieldWithLabel
          label="Tool id"
          placeholderText="Enter tool id"
          textValue={toolIdNo}
          onChangeHandler={(e: React.ChangeEvent<HTMLInputElement>) => {
            setToolIdNo(e.target.value)
          }}
          isDisabled={false}
          type="text"
          isMargin={true}
          noOptionsMessage="No tool id no entered"
        />
        <StyledTextFieldWithLabel
          label="Tool life"
          placeholderText="Enter tool life Eg: 10000"
          textValue={toolLife === 0 ? '' : toolLife.toString()}
          onChangeHandler={(e: React.ChangeEvent<HTMLInputElement>) => {
            const value = e.target.value
            if (value === '' || /^[1-9][0-9]*$|^0$/.test(value)) {
              setToolLife(value === '' ? 0 : Number(value))
            }
          }}
          isDisabled={false}
          type="text"
          isMargin={true}
          noOptionsMessage="No tool life entered"
        />
      </Stack>

      <Stack
        spacing={2}
        direction="row"
        sx={{
          marginTop: '16px',
          display: 'flex',
          justifyContent: 'flex-end'
        }}
      >
        <Button variant="outlined" onClick={props.closeHandler}>
          Cancel
        </Button>
        <Button
          variant="contained"
          sx={{ color: '#fff' }}
          onClick={() =>
            props.isEditMode && props.selectedTool
              ? props.editTool &&
                props.editTool(props.selectedTool.toolId, {
                  toolType: toolType.value,
                  toolId: toolIdNo,
                  toolSize: toolSize,
                  toolLife: toolLife
                })
              : props.addTool &&
                props.addTool({
                  toolType: toolType.value,
                  toolId: toolIdNo,
                  toolSize: toolSize,
                  toolLife: toolLife
                })
          }
        >
          {props.isEditMode ? 'Update' : 'Add tool'}
        </Button>
      </Stack>
    </StyledModal>
  )
}

export default ToolUploadModal
